import { checklistErrorTypes, checklistStatusTypes } from 'constants/checklist'
import { trackKinds } from 'constants/twilio'
import { isElectron } from 'helpers/electron'
import { userTypes } from 'helpers/user'
import {
    dispatchSetChecklistError,
    dispatchSetChecklistStatus,
    dispatchSetChecklistStep,
} from 'store/dispatcher'
import { isValidDevice, isValidBrowser, deviceAVDetails } from 'utils/device'
import { logger } from 'utils/logger'
import {
    checkDownloadSpeed,
    networkSpeedStore,
    NETWORK_LOWER_THRESHOLD,
    NETWORK_SPEED_KBPS,
} from 'utils/networkSpeed'

export const dispatchError = err => {
    dispatchSetChecklistStatus(checklistStatusTypes.ERROR)
    dispatchSetChecklistError(err)
}

const electron = isElectron()

export const performChecks = ({ userType }) => async dispatch => {
    try {
        /* Device Check */
        dispatchSetChecklistStep(checklistErrorTypes.DEVICE)
        const deviceValidity = await isValidDevice(userType)
        if (!deviceValidity) {
            dispatchError(checklistErrorTypes.DEVICE)
            throw new Error(`User tried to login with unsupported device`)
        }

        /* Browser Check */
        dispatchSetChecklistStep(checklistErrorTypes.BROWSER)
        const browserValidity = await isValidBrowser()
        if (!electron && !browserValidity) {
            dispatchError(checklistErrorTypes.BROWSER)
            throw new Error(`User tried to login with unsupported browser`)
        }

        /* Network Check */
        let speedKbps = 0
        try {
            dispatchSetChecklistStep(checklistErrorTypes.NETWORK)
            speedKbps = await checkDownloadSpeed()
            networkSpeedStore.set(speedKbps) // store the speed in localStorage for api calls
        } catch (error) {
            dispatchError(checklistErrorTypes.NETWORK)
            logger.error({
                msg: 'network check failed',
                error,
            })
            throw new Error(
                `User's netowrk b/w is ${speedKbps}kbps.
            Min reqd. threshold - ${NETWORK_LOWER_THRESHOLD}kbps`
            )
        }

        /* Audio Video Hardware Check */
        dispatchSetChecklistStep(checklistErrorTypes.AUDIO_VIDEO)
        const isTeacher = userType === userTypes.TEACHER
        const isStudent = userType === userTypes.STUDENT

        const {
            hasMicrophone,
            hasWebcam,
            hasBlockedOrResetAudio,
            hasBlockedOrResetVideo,
            shouldAskForPermissions,
        } = await deviceAVDetails()

        // block teacher if no access to audio or video
        if (isTeacher && (!hasWebcam || !hasMicrophone)) {
            const error = {
                type: !hasWebcam
                    ? checklistErrorTypes.VIDEO_404
                    : checklistErrorTypes.AUDIO_404,
                kind: !hasWebcam ? trackKinds.video : trackKinds.audio,
            }
            dispatchError(error.type)
            throw new Error(`User has no access to ${error.kind}`)
        }

        // block student if no access to audio
        if (isStudent && !hasMicrophone) {
            dispatchError(checklistErrorTypes.AUDIO_404)
            throw new Error('User has no access to audio')
        }

        if (hasBlockedOrResetVideo) {
            dispatchError(checklistErrorTypes.AUDIO_VIDEO)
            throw new Error('User has blocked video')
        }

        if (hasBlockedOrResetAudio) {
            dispatchError(checklistErrorTypes.AUDIO_VIDEO)
            throw new Error('User has blocked audio')
        }

        return shouldAskForPermissions
    } catch (error) {
        logger.error({
            msg: 'performChecks failed',
            error,
        })
    }
}
